module.exports = __webpack_public_path__ + "img/AngryButterfly.db20df94.svg";